import React from "react";
import { message } from "antd";

import { DeleteIcon } from "src/components";
import { compose } from "src/helpers";
import { withDeleteTab } from "src/modules/tab/operations";
import { captureException } from "@sentry/react";

const DeleteView = (props) => {
    const { deleteTab, id } = props;

    const handleDelete = async () => {
        try {
            await deleteTab(id);
            message.success("Deleted!");
        } catch (err) {
            captureException(err)
            message.error("Failed!");
        }
    };

    return <DeleteIcon {...props} onConfirm={handleDelete} />;
};

export default compose(withDeleteTab)(DeleteView);
